import { RefCallback, useState, useCallback } from 'react';

type Size = {
  width: number;
  height: number;
};

const initialSize: Size = {
  width: 0,
  height: 0,
};

export const useElementDimensions = <T extends HTMLElement>(): [RefCallback<T>, Size] => {
  const [size, setSize] = useState(initialSize);

  const refCallback = useCallback<RefCallback<T>>(node => {
    if (!node) {
      return setSize(initialSize);
    }
    const { width, height } = node.getBoundingClientRect();
    setSize({ width, height });
  }, []);

  return [refCallback, size];
};
